<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">จำหน่ายสินค้าโรงงาน</h2>
            <div class="row" style="font-size: 20px">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">รหัสพนักงาน</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.employee"
                                :options="optionEmployee"
                                track-by="id"
                                :customLabel="labelEmployee"
                                :show-labels="false"
                                placeholder="เลือกพนักงาน">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">เลขที่เอกสาร</label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.rc_number"
                                          mask="RC111111111"
                                          placeholder="เลขที่ RC"
                                          class="form-control"
                                          type="text" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">วันที่</label>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.date"
                                type="date"
                                :format="changeFormat"
                                :lang="lang"
                                class="w-100"
                                placeholder="วันที่อัพเดต" >
                            </date-picker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table table-responsive" style="min-height: 350px; padding-top: 50px;font-size: 20px">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th>ลำดับ</th>
                        <th>รหัสสินค้าโรงงาน</th>
                        <th>ชื่อสินค้าโรงงาน</th>
                        <th>จำนวน</th>
                        <th>ราคา</th>
                        <th>ราคารวม</th>
                        <th>เพิ่ม/ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(detail , index) in form.details">
                        <td>{{++index}}</td>
                        <td>
                            <multiselect
                                style="font-size: 22px"
                                v-model="detail.factory"
                                :options="optionFactory"
                                track-by="id"
                                :customLabel="labelFactory"
                                :show-labels="false"
                                placeholder="เลือกสินค้าโรงงาน">
                            </multiselect>
                            <div style="display: none">{{detail.factory_id = detail.factory ? detail.factory.id : ''}}</div>
                        </td>
                        <td>
                            {{detail.factory ? detail.factory.name : ''}}
                        </td>
                        <td width="200px">
                            <input class="form-control" v-model="detail.quantity"/>
                        </td>
                        <td>
                            {{detail.price = detail.factory ? detail.factory.price : 0 | currency}}
                        </td>
                        <td>
                            {{detail.total = parseFloat(detail.price) * parseFloat(detail.quantity ? detail.quantity : 0) | currency}}
                        </td>
                        <td>
                            <!--เพิ่ม-->
                            <button type="button"
                                    @click="addItemArray"
                                    v-if="form.details.length == index"
                                    class="btn btn-primary">
                                <icon name="plus"></icon>
                            </button>
                            <!--ลบ-->
                            <button type="button"
                                    @click="removeItemArray(index)"
                                    v-if="index < form.details.length"
                                    class="btn btn-danger">
                                <icon name="trash"></icon>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col text-right font-weight-bold">
                <label>ยอดรวม : &nbsp;</label>
                <span>{{sumTotal | currency}} บาท</span>
            </div>
            <div class="col text-center">
                <button class="btn btn-success" type="button" @click="showTransactionModal">
                    <icon name="save"></icon>
                    บันทึก
                </button> &nbsp;
                <button class="btn btn-outline-secondary" type="button" @click="goToFactoryEmployeeTable">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
            <br>
        </div>
        <b-modal hide-footer hide-header ref="transaction">
            <transaction-modal @submit="saveFactoryEmployee"/>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Multiselect from "vue-multiselect";
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment';
    import MaskedInput from 'vue-masked-input'
    import TransactionModal from "./TransactionModal";

    export default {
        name: "FactoryProductSaleInformation",
        components : {TransactionModal, Multiselect,DatePicker,MaskedInput},
        data(){
            return {
                optionEmployee : [],
                optionFactory : [],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
                items: [
                    {
                        text: "รายการจำหน่ายสินค้าโรงงาน",
                        to: {name: "factory-product-sale"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
            }
        },
        created() {
            this.getEmployeeAll();
            this.getFactoryAll();
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.FactoryEmployeeSale.form
                },
                user : state=>{
                    return state.Auth.user;
                },
            }),
            sumTotal(){
                return this.form.details.reduce((carry, detail) => {
                    return carry + detail.total
                }, 0);
            },
        },
        methods:{
            labelEmployee(option){
                return `${option.employee_no} - ${option.name}`
            },
            labelFactory(option){
                return `${option.code} - ${option.name}`
            },
            showTransactionModal(){
                this.form.total = this.sumTotal;
                this.$refs.transaction.show();
            },
            hideTransactionModal(){
                this.$refs.transaction.hide();
            },
           getEmployeeAll(){
               this.$store.dispatch("Employee/getEmployeeAll").then(employee=>{
                   this.optionEmployee = employee;
               });
           },
            getFactoryAll(){
                this.$store.dispatch("FactoryEmployee/getFactoryEmployeeAll").then(factory=>{
                  this.optionFactory = factory;
                })
            },
            addItemArray(){
                this.$store.dispatch("FactoryEmployeeSale/addData")
            },
            removeItemArray(index){
                this.$store.dispatch("FactoryEmployeeSale/removeData",index)
            },
            saveFactoryEmployee(val){
                if(val){
                    if(!this.form.employee){
                        alert("กรุณาเลือกพนักงาน");
                    }else if(!this.form.date){
                        alert("กรุณาเลือกวันที่");
                    }
                    else{
                        this.form.date = moment(this.form.date).format('YYYY-MM-DD');
                        this.form.employee_id = this.form.employee.id;
                        this.form.user_id = this.user.id;
                        this.$store.dispatch("FactoryEmployeeSale/saveFactoryEmployeeSale",{
                            id : this.form.id,
                            data : this.form,
                        }).then(res=>{
                            if (res == 'fail')
                                alert('สินค้าไม่พอจำหน่าย')
                            else
                                this.goToFactoryEmployeeTable();
                        }).catch(()=>{
                            alert('บันทึกไม่สำเร็จ');
                        })
                    }
                }
                this.hideTransactionModal();
            },
            goToFactoryEmployeeTable(){
                this.$router.push("/factory-product-sale")
            }
        },
    }
</script>

<style scoped>
    thead {
        background-color: grey;
    }
    tbody {
        background-color: white;
    }
</style>
